export default {
    enterprise: 'エンタープライズプラン',
    individual: '個人プラン',
    organization: '法人プラン',
};
